/**
 * Whether a pensioner must have sent the necessary documents of their
 * profiles to consult the announcements.
 *
 * Temporarily off while Ani seniors adds the documents to the existing
 * pensioner profiles: an ACTIVE or FREE pensioner reaches the announcements
 * whatever documents are filled. Set back to true once the profiles are
 * complete.
 * @type {boolean}
 */
export const CHECK_NECESSARY_DOCUMENTS = false;
